<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Previous company tax exemption"
      text="Create previous company tax exemption"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="taxExemption"
                v-validate="'required'"
                label="Tax Exemption"
                :items="taxExemptions"
                :item-text="item => '['+item.code+'] - '+ item.name"
                item-value="id"
                :error-messages="errors.collect('taxExemption')"    
                data-vv-name="taxExemption" 
                data-vv-as="tax exemption"
                outlined
              >
                <template v-slot:item="data">
                  <v-list-item-content style="width:270px">
                    <div class="font-weight-bold">
                      [{{ data.item.code }}] - {{ data.item.name }}
                    </div>
                    <div
                      class="font-weight-bold"
                      v-html="data.item.description"
                    />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
              />
            </v-col>
          </v-row>
        </v-container> 
      </form> 

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-10"
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"     
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      companyEmployeeUid: {
        type: String,
        required: true,
      },
      existingTaxExemption: {
        type: Array,
        required: true,
      },
      recordedDate: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,
        amount: null,
        taxExemption: null,
        taxExemptions: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 

        this.loading = true

        this.$api.taxExemptions().list({ year: this.yearFilter })
          .then(res => {
            this.taxExemptions = _.orderBy(res.data.filter(data => {
              return !this.existingTaxExemption.includes(data.id)
            }), ['name'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
          
            this.progressing = true

            this.$api.companyEmployeeTaxExemptions().create(this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
              .catch(error => {
                this.progressing = false
                if (error.response.status === 405) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.message, 
                  })
                }
              })
          })
      },
      prepareFormData () {
        return {
          company_employee_uid: this.companyEmployeeUid,
          tax_exemption_id: this.taxExemption,
          amount: this.amount.toString().replaceAll(',', ''),
          recorded_date: this.recordedDate,
        }
      },
    },
  }
</script>
